// Stable per-browser session identifier used to segment analytics events.
// Persisted in localStorage; never sent anywhere except the Zhelta backend.
const KEY = 'zhelta_session_id';

function uuid() {
  try {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  } catch (_e) { /* noop */ }
  return 'sess-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getSessionId() {
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = uuid();
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch (_e) {
    return uuid();
  }
}
